<template>
  <component :is="companyData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="companyData === undefined">
      <h4 class="alert-heading">獲取公司時出錯</h4>
      <div class="alert-body">
        找不到相關公司記錄。請查看
        <b-link class="alert-link" :to="{ name: 'companys-list' }">
          公司列表
        </b-link>
      </div>
    </b-alert>
    <company-edit-tab-information
      v-if="companyData"
      :company-data="companyData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import companyStoreModule from "../companyStoreModule";
import companyEditTabInformation from "./companyEditTabInformation.vue";

export default {
  components: {
    companyEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const companyData = ref({ id: 0 });
    const company = {
      id: 0,
    };

    const company_APP_STORE_MODULE_NAME = "company";

    if (!store.hasModule(company_APP_STORE_MODULE_NAME))
      store.registerModule(company_APP_STORE_MODULE_NAME, companyStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(company_APP_STORE_MODULE_NAME))
        store.unregisterModule(company_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "receipt-format-company-create") {
        companyData.value = company;
      } else {
        companyData.value = {
            "id":"COM0031", 
            "sort_order":"1",
            "address":"新界粉嶺",
            "tel": "91234567",
            "fax": "24799753",
            "website": "www.google.com",
            "email": "chantaiman@gmail.com",
            "updated_date":"17-07-2022,13:00",
            "created_at":"17-07-2022,13:00"
        };
        // store
        //   .dispatch("company/fetchCompany", { id: router.currentRoute.params.id })
        //   .then((response) => {
        //     companyData.value = response.data.companys[0];
        //     console.log(companyData.value)
        //   })
        //   .catch((error) => {
        //     console.log("error when fetching company", error);
        //     if (error.response.status === 404) {
        //       companyData.value = undefined;
        //     }
        //   });
      }
    };

    onMounted(() => {
      refetchData();
    });

    return {
      companyData,
      refetchData,
    };
  },
};
</script>
